const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 20px',
    minWidth: 500,
    minHeight: 350,
  },

  dialogContainer: {
    display: 'flex',
    flexDirection: 'row',
  },

  tableRoot: {
    margin: 0,
  },

  header: {
    marginBottom: 20,
    width: '100%',
  },

  tableRow: {
    height: '55px',
  },

  checkCell: {
    width: '45px',
    flex: 'none',
  },

  selectedColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minWidth: 350,
    borderLeft: '1px solid #f3f4f5',
    marginLeft: 24,
    overflow: 'hidden',
  },

  selectedColumnList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: 296,
    overflow: 'auto',
    padding: '0 24px',
    margin: '8px 0 0 0',
    listStyleType: 'none',
  },

  drag: {
    listStyleType: 'none',
    pointerEvents: 'auto !important',
  },

  selectedColumn: {
    margin: '0 0 10px 0',
    cursor: 'move',
  },

  checkboxLabel: {
    fontSize: '16px',
  },

  form: {
    padding: '0 20px',
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
  },

  actionRow: {
    padding: '0 20px 10px',
    boxShadow: 'none',
  },
});

export default styles;
